export type AccountType = 'bank' | 'cash' | 'credit_card' | 'savings' | 'investment';

export interface Account {
  id: number;
  user_id: number;
  name: string;
  type: AccountType;
  balance: number;
  currency: string;
  description?: string;
  color?: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface CreateAccountRequest {
  name: string;
  type: AccountType;
  balance: number;
  currency?: string;
  description?: string;
  color?: string;
}

export interface UpdateAccountRequest {
  name?: string;
  description?: string;
  color?: string;
  is_active?: boolean;
}

export const ACCOUNT_TYPE_LABELS: Record<AccountType, string> = {
  bank: 'Bank Account',
  cash: 'Cash',
  credit_card: 'Credit Card',
  savings: 'Savings',
  investment: 'Investment',
};

export const ACCOUNT_TYPE_COLORS: Record<AccountType, string> = {
  bank: '#0066CC',
  cash: '#10B981',
  credit_card: '#EF4444',
  savings: '#8B5CF6',
  investment: '#F59E0B',
};
